module.exports = __webpack_public_path__ + "img/65.3915c012.png";